import { fetcher } from "helpers/fetcher";

import {
  TGetManualJobSuggestionReq,
  TGetManualJobSuggestionRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getManualJobSuggestion = async (
  payload?: TGetManualJobSuggestionReq
) => {
  return await fetcher<
    TGetManualJobSuggestionRes,
    TGetManualJobSuggestionReq["data"]
  >(ENDPOINT.BU.GET_MANUAL_JOB_SUGGESTION, {
    data: payload?.data,
    headers: {
      [API_HEADER.VERSION]: ENDPOINT.BU.GET_MANUAL_JOB_SUGGESTION.version,
      [API_HEADER.BU_ID]: payload?.idBu,
    },
  });
};

export const queryGetManualJobSuggestion = async (
  params?: TGetManualJobSuggestionReq
) => {
  return (await getManualJobSuggestion(params)).data;
};

queryGetManualJobSuggestion._key = (
  params?: TGetManualJobSuggestionReq,
  key?: string
) => [ENDPOINT.BU.GET_MANUAL_JOB_SUGGESTION.url, params, key];
